import { breakpoints, theme, ThemeDefinition } from "@shapeable/theme";
import { WARM_GREY } from "@shapeable/ui";
import { css } from "styled-components";

export const YELLOW = '#FFCA04';
export const YELLOW_DARK = '#FCB10F';
export const YELLOW_ORANGE = '#F79616';

export const AMPARO_MID_GREEN = '#6EBD44';

export const AMPARO_MID_PURPLE = '#774198';
export const AMPARO_DARK_PURPLE = '#322B4D';
export const AMPARO_VERY_DARK_PURPLE = '#322C3B';

export const themeOverrides: ThemeDefinition = {
  light: {
    color: {

      darkBackground: '#202124',
      lightBackground: '#F8F8F8',
  
      midBrand: YELLOW_DARK,
      primary: AMPARO_MID_GREEN,
  
  
      linkHover: AMPARO_MID_PURPLE,
      link: AMPARO_MID_PURPLE,
      // linkInvertedHover: YELLOW,
      // linkActive: YELLOW,
  
      // menuItemLinkHover: YELLOW_DARK, 
      // menuItemLinkActive: YELLOW_DARK, 
      // invertedMenuItemLinkHover: YELLOW_DARK, 
  
    },
  },
  font: {
    family: {
      serif: "'Cormorant', georgia, serif",
      sans: 'Readex Pro, sans-serif',
      heading: 'Readex Pro, sans-serif',
      copy: 'Readex Pro, sans-serif',
    }
  },
};


/* 
--------------------

  Layout Styles
  
  NB: This is the appropriate place to override styling for this specific site, based on BEM-style class name targets 
  
--------------------
*/

export const LayoutStyles = breakpoints({
  base: css`

    .page-home .shp--page-layout-standard__banner-titles div div {
      flex-direction: column;
      gap: 0.25em;

      h1 {
        align-self: flex-start;
      }
    }

    .shp--slice-layout-banner-tout {
      h1 {
        font-weight: 300;
      }
    }

    .shp--slice-intro {
      font-size: 1.75em;
      text-align: left;
      line-height: 1.25em;
    }

    .shp--site-menu-bar__title {
      color: ${theme.COLOR('light')}
    }

    .shp--slice-key-message {
      text-align: left;

      .shp--content {
        line-height: 1.10em;
        font-weight: 400;
      }
      
      .shp--slice-key-message__links {
        align-items: flex-start;
      }
    }

    .shp--slice-layout-content-with-image {
      .shp--content-node {
        color: ${theme.COLOR('inherit')};
      }
      li::before {
        color: ${theme.COLOR('inherit')};
      }
    }

    .shp--slice-layout-latest-insights {
      .shp--slice-header {
          display: none;
        }
    }

    #customers .shp--button {
      color: ${theme.COLOR('light')};
      ${theme.FILL('light')};
      border: 2px dotted ${theme.COLOR('light')};
      &:hover {
        color: ${theme.COLOR('#FCB10F')};
        ${theme.FILL('#FCB10F')};
        border: 2px dotted ${theme.COLOR('#FCB10F')};
      }
    }

    .shp--slice-layout-section {
      h1 {
        .shp--content-with-icon-embed {
          margin: 0;
        }
      }
    }

  `,
  tablet: css`
    .shp--slice-intro {
      font-size: 2em;
      text-align: left;
      line-height: 1.25em;
    }

  `,
  desktop: css`
    .shp--slice-section-color-block {
      min-height: 600px;
    }

    .page-home .shp--page-layout-standard__banner-titles div div {
      gap: 1em;
    }

    
    
  `,
});